export default __webpack_public_path__ + "static/media/427852_b.6857b038.png";